
class DataTable {

  constructor(table_id, run_setup) {
    this.table_id = table_id;
    this.table_elem = $(this.table_id);
    this.serverSide = false

    this.searching = true;
    this.paging = true;
    this.info = true;
    this.domOptions = false;
    this.pageScrollPos = 0
    this.useJsData = false;
    this.addStatusSearchEvent=true;
    this.pageLength = 15;
    this.domstr = "<'row'<'col-sm-12'B>>"+
    "<'row't>" +
    "<'row'<'col-sm-3'l><'col-sm-4'i><'col-sm-4'p>>"

    if(run_setup) {
      this.setupTable();
    }
  }

  rowCallback(row, data) {

  }

  setupTable() {
    var domstr = "<'row'<'col-sm-12'B>>"+
    "<'row't>" +
    "<'row'<'col-sm-3'l><'col-sm-4'i><'col-sm-4'p>>"

    var dtOptions = {
      buttons: [
          {
              extend: 'colvis',
              //postfixButtons: [ 'colvisRestore' ]
          }
      ],
        //dom: 'Bltip',
        dom: this.domstr,
        stateSave: true,
        stateDuration: 60 * 60 * 24 * 7,
        //dom: 'Bfrtip',
        order: this.ordering(),
        serverSide: this.serverSide,
        searching: this.searching,
        paging: this.paging,
        pageLength: this.pageLength,
        info: this.info,
        //bBootstrapLayout: true,
        columns: this.getTableColumns(),
        rowId: 'id',
        rowCallback: this.rowCallback,
        // stops page from jittering on reload data
        preDrawCallback: function (settings) {
        this.pageScrollPos = $('body').scrollTop();
        },
        drawCallback: function (settings) {
          $('body').scrollTop(this.pageScrollPos);
        }

      }


    if (this.domOptions) {
      dtOptions.dom = this.domOptions;
    }
    if (this.useJsData) {
      dtOptions.data = this._getTableAjax();
    } else {
      dtOptions.ajax = this._getTableAjax();
    }
    if (this.footerCallback) {
      dtOptions.footerCallback = this.footerCallback
    }
    // disable pop up errors
    $.fn.dataTable.ext.errMode = 'none';

    this.table = $(this.table_id).DataTable(dtOptions);

    this.table.on( 'error.dt', function ( e, settings, techNote, message ) {
    console.log( 'An error has been reported by DataTables: ', message );
    });

  }

  // adds the custom filters to the dom
  addOrderFilters(filterHTML) {

    $(filterHTML).insertAfter(this.table_id + '_wrapper .dt-buttons');
    //$(this.table_id + '_wrapper').addClass('row');

    $(this.table_id + "_wrapper .dt-buttons").appendTo('#columnVisabilityContainer')

    $(this.table_id + "_wrapper .dataTables_filter").html(filterHTML);
    $(this.table_id  + "_wrapper .row").css('margin-top', '0px');
    $(this.table_id + "_wrapper .form-group").css('text-align', 'center');
    $(this.table_id  + "_wrapper .dataTables_filter label").css('float', 'none');
    $(this.table_id).css('width','100%');
    var self = this;
    if (this.addStatusSearchEvent) {
      $('#orderStatusFilter').on('change', function () {
            var val = $.fn.dataTable.util.escapeRegex(
                $(this).val()
            );
            console.log("select filter val " + val)

            self.table.column('order_status:name')
                .search( val, true, false )
                .draw();
            });
    } else {
      $('#orderStatusFilter').on('change', function () {
            self.refresh();
            });
    }


  }

  refresh() {
    this.table.ajax.reload( null, false );
  }


}
